const MESES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
]; // fmt: skip

/**
 * «2026-01» → «Enero 2026». El periodo se lee, no se descifra.
 *
 * Vive suelto porque lo pintan la barra del módulo, la portada y el cierre. Que
 * una pantalla dijera «2026-01» mientras la de al lado dice «Enero 2026» es el
 * tipo de detalle que hace dudar de si hablan del mismo mes.
 */
export function mesEnLetras(periodo: string): string {
  const [anio, mes] = periodo.split("-");
  const nombre = MESES[Number(mes) - 1];
  if (!nombre || !anio) return periodo;
  return `${nombre[0]?.toUpperCase()}${nombre.slice(1)} ${anio}`;
}

/** «2026-01» → «enero», para meterlo en medio de una frase. */
export function mesSuelto(periodo: string): string {
  const mes = MESES[Number(periodo.split("-")[1]) - 1];
  return mes ?? periodo;
}

/**
 * El tramo que cubre un extracto, dicho corto: «Ene 2026», o «Ene–Mar 2026»
 * cuando el archivo abarca varios meses.
 *
 * Hace falta porque la tabla de lo cargado decía cuenta, movimientos, entró,
 * salió y saldo, y no decía DE CUÁNDO: con el extracto de enero y el de
 * febrero de la misma cuenta, las dos filas se ven idénticas. Y los de Alfin
 * traen cinco meses en un archivo, así que un mes suelto mentiría.
 */
export function tramoCorto(
  desde: string | null,
  hasta: string | null,
): string | null {
  const a = mesDe(desde);
  const b = mesDe(hasta);
  if (!a) return null;
  if (!b || (a.mes === b.mes && a.anio === b.anio))
    return `${CORTOS[a.mes]} ${a.anio}`;
  if (a.anio === b.anio) return `${CORTOS[a.mes]}–${CORTOS[b.mes]} ${a.anio}`;
  return `${CORTOS[a.mes]} ${a.anio} – ${CORTOS[b.mes]} ${b.anio}`;
}

const CORTOS = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Oct",
  "Nov",
  "Dic",
]; // fmt: skip

function mesDe(iso: string | null): { mes: number; anio: string } | null {
  if (!iso) return null;
  const [anio, mes] = iso.slice(0, 10).split("-");
  const n = Number(mes) - 1;
  if (!anio || Number.isNaN(n) || n < 0 || n > 11) return null;
  return { mes: n, anio };
}
